export default function (values: Array<number>): number {
  if (!values.length) {
    return 0;
  }
  let total = 1;
  for (const value of values) {
    total *= value;
  }
  return total;
}
